var comments = require('./language-js/comments');

module.exports = {
  handleComments: comments
};